import { createStore } from 'vuex'

// 从 localStorage 加载初始状态
const savedState = {
  classtype: JSON.parse(localStorage.getItem('classtype')) || '1',
  activeNavIndex: JSON.parse(localStorage.getItem('activeNavIndex')) || 0,
  // 登录状态相关
  userToken: localStorage.getItem('userToken') || null,
  refreshToken: localStorage.getItem('refreshToken') || null,
  userType: localStorage.getItem('userType') ? parseInt(localStorage.getItem('userType')) : null,
  userId: localStorage.getItem('userId') || null,
  tenantId: localStorage.getItem('tenantId') || null,
  userInfo: JSON.parse(localStorage.getItem('userInfo') || 'null') || {}
};

// 定义初始状态
const initialState = {
  classtype: savedState.classtype,
  activeNavIndex: savedState.activeNavIndex,
  // 用户登录状态
  userToken: savedState.userToken,
  refreshToken: savedState.refreshToken,
  userType: savedState.userType, 
  userId: savedState.userId,
  tenantId: savedState.tenantId,
  userInfo: savedState.userInfo,
  isLoggedIn: !!savedState.userToken
};

// 导出 Vuex store 实例
export default createStore({
  // 设置初始状态
  state: initialState,
  getters: {
    getClassType: (state) => {
      return state.classtype
    },
    getActiveNavIndex: (state) => {
      return state.activeNavIndex
    },
    // 登录状态相关getters
    isLoggedIn: (state) => {
      return !!state.userToken
    },
    userInfo: (state) => {
      return state.userInfo
    },
    userToken: (state) => {
      return state.userToken
    },
    refreshToken: (state) => {
      return state.refreshToken
    },
    userType: (state) => {
      return state.userType
    },
    userId: (state) => {
      return state.userId
    },
    tenantId: (state) => {
      return state.tenantId
    }
  },
  mutations: {
    classtype(state, newval) {
      state.classtype = newval
      localStorage.setItem('classtype', JSON.stringify(state.classtype));
    },
    activeNavIndex(state, newval) {
      state.activeNavIndex = newval
      localStorage.setItem('activeNavIndex', JSON.stringify(state.activeNavIndex));
    },
    // 登录状态管理mutations
    setLoginState(state, { token, refreshToken, userType, userId, tenantId, userInfo }) {
      state.userToken = token
      state.refreshToken = refreshToken
      state.userType = userType
      state.userId = userId
      state.tenantId = tenantId
      state.userInfo = userInfo || {}
      state.isLoggedIn = !!token
      
      // 持久化到localStorage
      if (token) {
        localStorage.setItem('userToken', token)
        localStorage.setItem('refreshToken', refreshToken || '')
        localStorage.setItem('userType', userType)
        localStorage.setItem('userId', userId)
        localStorage.setItem('tenantId', tenantId || '')
        localStorage.setItem('userInfo', JSON.stringify(userInfo || {}))
      }
    },
    clearLoginState(state) {
      state.userToken = null
      state.refreshToken = null
      state.userType = null
      state.userId = null
      state.tenantId = null
      state.userInfo = {}
      state.isLoggedIn = false
      
      // 清除localStorage
      localStorage.removeItem('userToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('userType')
      localStorage.removeItem('userId')
      localStorage.removeItem('tenantId')
      localStorage.removeItem('userInfo')
    },
    updateUserInfo(state, userInfo) {
      state.userInfo = { ...state.userInfo, ...userInfo }
      localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
    }
  },
  actions: {
    // 登录action
    login({ commit }, { token, refreshToken, userType, userId, tenantId, userInfo }) {
      commit('setLoginState', { token, refreshToken, userType, userId, tenantId, userInfo })
    },
    // 退出登录action  
    logout({ commit }) {
      commit('clearLoginState')
    },
    // 更新用户信息action
    updateUserInfo({ commit }, userInfo) {
      commit('updateUserInfo', userInfo)
    }
  },
  modules: {
  },
})